import { render, staticRenderFns } from "./PopulationIncomeConfig.vue?vue&type=template&id=8dddc1ee&scoped=true&"
import script from "./PopulationIncomeConfig.vue?vue&type=script&lang=js&"
export * from "./PopulationIncomeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dddc1ee",
  null
  
)

export default component.exports